import { ROOT_URL } from "../actions";

export const picklistApi = {
  GET_PICK_LIST_DATA: `${ROOT_URL}/hms/pick_list/`,
  DOWNLOAD_PICK_LIST_DATA: `${ROOT_URL}/hms/export_pick_list/`,
  ACTION_REQUEST_COUNT: `${ROOT_URL}/hms/get_action_request_count/`,
};
